export type TopLevelDomain = string;

export enum AppStage {
  Development = 'development',
  Staging = 'staging',
  Production = 'production',
  Sandbox = 'sandbox',
  Test = 'test',
}

export function getTopLevelDomainForStage(stage: AppStage): TopLevelDomain {
  switch (stage) {
    case AppStage.Development:
      return '.lmnddev.com';
    case AppStage.Production:
      return '.lemonade.com';
    case AppStage.Sandbox:
      return '.lmndsandbox.com';
    case AppStage.Staging:
      return '.lmndstaging.com';
    case AppStage.Test:
      return 'localhost';
    default:
      throw new Error(`Unknown stage ${stage as unknown as string}`);
  }
}

export enum EdgeService {
  ChatPlatform = 'chat',
  ConversationRouter = 'conversation-router',
  Cx = 'cx',
  Monolith = 'monolith',
  Uniclient = 'uniclient',
  UsersEdge = 'users-edge',
  Consumer = 'consumer',
}

export const PRODUCTION_URLS: { readonly [key in EdgeService]: string } = {
  [EdgeService.ChatPlatform]: 'https://chat-api.lemonade.com',
  [EdgeService.ConversationRouter]: 'https://conversations.lemonade.com',
  [EdgeService.Cx]: 'https://cx.lemonade.com',
  [EdgeService.Monolith]: 'https://www.lemonade.com',
  [EdgeService.Uniclient]: 'https://chat.lemonade.com',
  [EdgeService.UsersEdge]: 'https://my.lemonade.com',
  [EdgeService.Consumer]: 'https://me.lemonade.com',
};

export function getEdgeServiceUrl(
  edgeService: `${EdgeService}`,
  env: `${AppStage}`,
  envId: string,
  isPublic = false,
): string {
  switch (env) {
    case AppStage.Development:
    case AppStage.Sandbox:
    case AppStage.Staging: {
      const regionalDomain = getTopLevelDomainForStage(env as AppStage);
      return `https://${edgeService}-${envId}${isPublic ? '.public' : ''}${regionalDomain}`;
    }

    case AppStage.Production: {
      return PRODUCTION_URLS[edgeService];
    }

    default:
      throw new Error('Invalid Env');
  }
}

export function buildEdgeServiceUrl(
  edgeService: `${EdgeService}`,
  env: `${AppStage}`,
  envId: string,
  path?: string,
  isPublic = false,
): string {
  return getEdgeServiceUrl(edgeService, env, envId, isPublic) + (path ?? '');
}
